import cn from 'classnames';
import { Text, TextElement } from '@/shared/ui/core';
import { HTMLAttributes } from 'react';
import styles from './card.module.scss';


type ComponentType = HTMLAttributes<HTMLHeadingElement> & {
    as?: TextElement;
}


export function CardTitle ({ className, ...props }: ComponentType) {
    return (
        <Text
            variant='heading'
            weight='semibold'
            className={ cn(styles.title, className) }
            data-template="card-title"
            lineHeight={ 1 }
            { ...props }
        />
    );
}
